export const API_VERSION = 6;
export const PACKAGE = 'practice';
